<template>
  <div class="ima-shopping-cart">
    <h1 class="title">Warenkorb ({{itemsInShoppingCart}})</h1>

    <b-table class="ima-signs-list__table" :data="shoppingCart.data" :striped="true" :mobile-cards="true" :paginated="true" :per-page="25" :pagination-simple="true">

      <template slot-scope="props">

        <b-table-column field="id" label="ID" sortable numeric>
          {{ props.row.sign.id }}
        </b-table-column>

        <b-table-column field="thumbnail" label="Vorschau">
          <router-link :to="{ name: 'SIGN_DETAILS', params: { id: props.row.sign.id, variantId : props.row.variant.id}}">
            <ima-sign-thumbnail :sign="props.row.sign" />
          </router-link>
        </b-table-column>

        <b-table-column field="name" label="Name" sortable>
          {{ props.row.sign.name }}
        </b-table-column>

        <!--b-table-column field="name" label="Variante" sortable>
          {{ props.row.variant.name }}
        </b-table-column-->

        <b-table-column field="name" label="Menge">
          <b-input type="number" :value="props.row.amount" min="1" @input="(value)=>onAmountChange(props.row, value)">
          </b-input>
        </b-table-column>

        <b-table-column field="actions" label=" ">
          <div class="control">
            <router-link :to="{ name: 'SIGN_DETAILS', params: { id: props.row.sign.id, variantId: props.row.variant.id}}" class="button round-button is-primary">
              <b-icon icon="arrow_forward"></b-icon>
            </router-link>

            <button class="button round-button is-danger" type="button" @click="onSignRemove(props.row)">
              <span class="icon">
                <b-icon icon="delete" />
              </span>
            </button>
          </div>
        </b-table-column>

      </template>

      <div slot="empty">
        Zur Zeit sind keine Schilder im Warenkorb
      </div>
    </b-table>

    <button class="button floating-button" @click="onSubmit()" :disabled="itemsInShoppingCart===0">
      <b-icon icon="send" />
    </button>

  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import { updateSignAmount, removeSign } from '@/store/modules/shopping-cart'
import { openShoppingCartOverviewModalOpen } from '@/store/modules/modals'
import SignThumbnail from '@/components/SignThumbnail'

export default {
  name: 'ima-shopping-cart',
  components: {
    'ima-sign-thumbnail': SignThumbnail
  },
  computed: {
    ...mapState(['shoppingCart']),
    ...mapGetters(['itemsInShoppingCart'])
  },
  methods: {
    ...mapMutations([
      updateSignAmount,
      removeSign,
      openShoppingCartOverviewModalOpen
    ]),
    onAmountChange (item, amount) {
      this.updateSignAmount({ ...item, amount: parseInt(amount, 10) })
    },
    onSignRemove (item) {
      this.removeSign(item)
    },
    getThumbnailUrl ({ svgPath }) {
      return `${SERVER_URL}/svg/${svgPath}`
    },
    onSubmit () {
      this.openShoppingCartOverviewModalOpen()
    }
  },
  data () {
    return {}
  }
}
</script>


<style lang="scss" scoped>
.ima-shopping-cart {
}
</style>



// WEBPACK FOOTER //
// src/components/ShoppingCart.vue